import React from "react";
import { Typography } from "@mui/material";
import { Layout, SectionHead, SectionContent } from "@layouts/MainLayout";
import { useAuth } from "@context/AuthContext";
import { useTranslation } from "react-i18next";

const UserDashboard: React.FC = () => {
  const { name } = useAuth();
  const { t } = useTranslation();
  return (
    <Layout>
      <SectionHead title={t("general.dashboardHeader", { name: name })} />
    </Layout>
  );
};

export default UserDashboard;
